import { Validator } from '../../util/parse';

export interface AlgoliaIndex<T> {
  name: string;
  validator: Validator<T>;
}

export const makeAlgoliaIndex = <T,>(name: string, validator: Validator<T>): AlgoliaIndex<T> => ({
  name,
  validator,
});
